import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "44",
  height: "44",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "44",
      height: "44",
      fill: "#F4F4F4",
      rx: "4"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#DEDEDE",
      "fill-rule": "evenodd",
      d: "M25.848 24.384c0 2.125-1.777 3.957-3.931 3.957s-3.931-1.832-3.931-3.957c0-2.119 1.784-3.958 3.93-3.958 2.156 0 3.932 1.812 3.932 3.958m-6.77 0c0 1.575 1.274 2.857 2.839 2.857s2.839-1.282 2.839-2.857-1.274-2.858-2.84-2.858c-1.564 0-2.838 1.282-2.838 2.858",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#DEDEDE",
      "fill-rule": "evenodd",
      d: "M28.827 15.62h6.298c1.035 0 1.875.833 1.875 1.862v12.655C37 31.166 36.16 32 35.125 32H8.875A1.87 1.87 0 0 1 7 30.137V17.482c0-1.029.84-1.863 1.875-1.863h5.614c1.36 0 .901-2.619 2.63-2.619h9.05c1.721 0 1.3 2.62 2.658 2.62m-14.044 4.452a.204.204 0 0 0 .204-.205v-1.053a.204.204 0 0 0-.204-.205h-3.292a.205.205 0 0 0-.204.205v1.053c0 .113.092.205.204.205zm1.688 4.312c0 3.028 2.438 5.482 5.446 5.482s5.446-2.455 5.446-5.482c0-3.029-2.439-5.483-5.446-5.483-3.008 0-5.446 2.454-5.446 5.483",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }